var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileTypesIpa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDF1F7",
    d: "M21 6h-5.25a.75.75 0 01-.75-.75V0H4.125C3.505-.002 3.002.5 3 1.12v21.755c-.002.62.5 1.123 1.12 1.125h15.755c.62.002 1.123-.5 1.125-1.12V6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FC",
    d: "M20.672 4.922L16.082.328A1.122 1.122 0 0015.286 0H15v5.25c0 .414.336.75.75.75H21v-.286a1.12 1.12 0 00-.328-.792z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10.8h12v12H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5CEE0",
    d: "M11.96 14.913a.223.223 0 00-.081-.304l-.579-.333a.223.223 0 00-.304.082l-.885 1.55-.977 1.707-.815 1.426a.222.222 0 00.082.303l.578.334a.224.224 0 00.304-.082l1.132-1.981.732-1.28.813-1.422zm-3.016 1.852h-1.21a.532.532 0 00-.533.53v.53c0 .292.239.529.533.529h.25l.96-1.59zm2.558 0l-.889 1.589h3.137l-.8-1.59h-1.449zm-2.71 3.168l-.579-.333c-.106-.06-.203-.01-.217.111l-.1.874c-.015.121.057.165.158.096l.746-.51c.101-.07.097-.177-.01-.238zm7.476-3.168H15.13l.915 1.589h.222a.532.532 0 00.533-.53v-.53a.532.532 0 00-.533-.53zm-1.165.872c-.004-.005-.008-.014-.012-.022-.054-.1-.188-.359-.365-.696-.002-.004-.005-.008-.006-.013l-.042-.08-.03-.057-.026-.05c-.017-.03-.032-.06-.048-.091l-.016-.029-.054-.104-.016-.03c-.408-.773-.92-1.725-1.236-2.225-.552-.877-1.29-2.338-1.495-2.235-.288.145.605 2 .9 2.697.295.697 1.448 3.369 1.68 3.485.23.117.32.052.475-.012.154-.065.43-.28.29-.538zm.574 2.145c-.087.083-.293.264-.044.616s.805.369.878.602c0 0 .174-1.79-.834-1.218zm.085-.768l-.275-.53a.246.246 0 00-.326-.11l-.332.172a.219.219 0 00-.082.317l.348.553a.25.25 0 00.337.083l.237-.143a.265.265 0 00.093-.342z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.6 2.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 7.2,
    fill: "#4A99F9",
    rx: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M3.398 5.4V2.074h-.585V5.4h.585zm1.378 0V4.147h.662c.333 0 .596-.093.79-.278.194-.186.29-.439.29-.759s-.096-.572-.29-.758c-.194-.186-.457-.278-.79-.278H4.205V5.4h.571zm.605-1.704h-.605V2.525h.605c.185 0 .325.05.42.149.094.099.141.244.141.436s-.047.338-.141.437c-.095.1-.235.149-.42.149zM7.075 5.4l.269-.835h1.277l.278.835h.62L8.313 2.074H7.68L6.47 5.4h.605zm1.411-1.262H7.483l.5-1.536.503 1.536z"
  })))));
}

export default SvgFileTypesIpa;